import { INSTANCE_URL } from "Constants";
import { getRequest } from "NetworkCall";
export const SOCIALFEED_TOTAL_REACTION = "SOCIALFEED_TOTAL_REACTION";

// fc to Get Number of reaction on social feed posts
export function socialfeedreactioncount(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=socialfeedreactioncnt&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Socialfeed reaction count/total
        dispatch({ type: SOCIALFEED_TOTAL_REACTION, payload: data });
        callback({
          error: 0,
          data: "Analytics Socialfeed Total Reaction Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
}
